import React from 'react'

const HeroLayout = () => {
    return (
        <div>
            <section className="hero-layout">
                <div className="container-xl">
                    <div className="hero-content">
                        <p className="mini-title">
                            ELEGANCE<br />CRAFTED<br />TO PERFECTION
                        </p>
                        <h1 className="hero-title">
                            Discover Rajkot’s<br />Most Trusted<br />Jewellery Destination
                        </h1>
                        <p className="hero-desc">
                            Experience the timeless charm of <em>Tanishq</em>, from the
                            <strong> House of Tata </strong>— a legacy of trust and craftsmanship
                            shining bright on Yagnik Road since 2002.
                        </p>
                    </div>
                </div>

                <div className="hero-video">
                    <img
                        src="/assets/imgs/img.JPG" alt='jwellery'
                    />
                    <div className="video-overlay"></div>
                </div>
            </section>
        </div>
    )
}

export default HeroLayout